import { GraphQLClient } from 'graphql-request';
import { canUseDOM } from '@/utils/dom-utils';

const config = require('../../temp/config');

const apiHost = canUseDOM() ? window.location.origin : config.sitecoreApiHost;

const masterEndPoint = `${apiHost}/sitecore/api/graph/items/master`;
const edgeEndPoint = `${apiHost}${config.graphQLEndpointPath || '/sitecore/api/graph/edge'}`;

export const setUpGraphQLClient = (queryType: 'master' | 'edge' = 'edge') => {
  const endPoint = queryType === 'master' ? masterEndPoint : edgeEndPoint;
  return new GraphQLClient(endPoint, {
    headers: {
      sc_apikey: config.sitecoreApiKey,
    },
  });
};
export const graphQLClient = setUpGraphQLClient('edge');
